import { base64ToArrayBuffer } from "./FileUtils";
export function exportData(data, fileName, fileExtension) {
  let fileData = base64ToArrayBuffer(data);
  let bytes = new Uint8Array(fileData);

  let blob = new Blob([bytes], {
    type: "application/"+fileExtension,
  });
  let link = document.createElement("a");
  link.target = "_blank";
  link.rel = "noopener";
  const fileUrl = URL.createObjectURL(blob);
  link.download = fileName;
  link.href = fileUrl;
  

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link); 
} 
